import type { GridColDef } from '@mui/x-data-grid-pro';
import { AddButton } from '@src/common/components/button/AddButton';
import { FilterableTable } from '@src/common/components/FilterableTable';
import { LoadingSpinner } from '@src/common/components/LoadingSpinner';
import { PageLayout } from '@src/common/components/Page';
import { Timestamp } from '@src/common/time/Timestamp';
import { useExchangeRate } from '@src/exchangeRateManager/hooks/useExchangeRate';
import { SetExchangeRateModal } from '@src/exchangeRateManager/SetExchangeRateModal';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const ExchangeRateManager = () => {
  const { t } = useTranslation();
  const { exchangeRates, isLoading } = useExchangeRate();
  const [openModal, setOpenModal] = useState(false);

  const columns: GridColDef[] = [
    { field: 'startDate', headerName: t('exchangeRate.startDate'), flex: 1 },
    { field: 'endDate', headerName: t('exchangeRate.endDate'), flex: 1 },
    { field: 'usdToCad', headerName: t('exchangeRate.usdToCad'), flex: 1 },
    { field: 'cadToUsd', headerName: t('exchangeRate.cadToUsd'), flex: 1 },
    { field: 'enteredBy', headerName: t('exchangeRate.enteredBy'), flex: 1 },
  ];

  const rows = exchangeRates.map((rate) => ({
    id: rate.id,
    startDate: Timestamp.from(rate.startDate).formatUTCDate(),
    endDate: rate.endDate
      ? Timestamp.from(rate.endDate).formatUTCDate()
      : undefined,
    usdToCad: rate.usdToCad,
    cadToUsd: rate.cadToUsd,
    enteredBy: rate.enteredByName,
  }));

  const openNewRateModal = () => {
    setOpenModal(true);
  };
  const closeNewRateModal = () => {
    setOpenModal(false);
  };

  return (
    <PageLayout
      title={t('exchangeRate.historyRate')}
      rightBlock={
        <AddButton
          onClick={openNewRateModal}
          label={t('exchangeRate.new.shortTitle')}
        />
      }
      style={{
        margin: '0',
      }}
    >
      {isLoading && <LoadingSpinner />}
      {!isLoading && (
        <FilterableTable
          columns={columns}
          rows={rows}
          ariaLabel={t('exchangeRate')}
          paginationAndSortMode="client"
        />
      )}
      <SetExchangeRateModal
        open={openModal}
        onClose={closeNewRateModal}
        title={t('exchangeRate.new.title')}
      />
    </PageLayout>
  );
};
